import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-058266f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "saleHistory",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-primary text-center" }, "All available transaction history for this property can be viewed in the table below. By default, QuickSource will automatically select all transactions within 1 year for Comps and 3 years for the Subject property to write the Analysis of Sale or Transfer History for that property. Check Include Analysis of Prior Sale in my report to send this data to TOTAL on save.", -1))
const _hoisted_5 = { class: "mb-1 text-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "By default, automatically select all transactions within the last", -1))
const _hoisted_7 = ["selected"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_9 = ["selected"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "4", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "15" }, "15", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "All", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "years.", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "qs-table-container mb-2" }
const _hoisted_23 = { class: "qs-table noselect" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qs-table-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qs-table-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, " "),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Sale Date"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Recorded Date"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Price"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Type"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Arms Length?"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Seller"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Buyer"),
    /*#__PURE__*/_createElementVNode("div", { class: "qs-table-cell" }, "Doc #")
  ])
], -1))
const _hoisted_25 = { class: "qs-table-body" }
const _hoisted_26 = { class: "qs-table-cell text-center" }
const _hoisted_27 = ["onChange", "disabled", "checked"]
const _hoisted_28 = { class: "qs-table-cell" }
const _hoisted_29 = { class: "qs-table-cell" }
const _hoisted_30 = { class: "qs-table-cell" }
const _hoisted_31 = { class: "qs-table-cell" }
const _hoisted_32 = { class: "qs-table-cell" }
const _hoisted_33 = { class: "qs-table-cell" }
const _hoisted_34 = { class: "qs-table-cell" }
const _hoisted_35 = { class: "qs-table-cell" }
const _hoisted_36 = {
  key: 1,
  class: "mt-5 mb-5"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "No Sale History")
], -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "mt-5 mb-5"
}
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = { class: "noselect" }
const _hoisted_43 = ["checked", "disabled"]
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Exclude Non-Arms Length Transactions")
const _hoisted_45 = { class: "noselect" }
const _hoisted_46 = ["checked", "disabled"]
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Include a copy of this table in my report addenda")
const _hoisted_48 = { class: "mb-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Preview of data that will appear in Analysis of Sale or Transfer History:", -1))
const _hoisted_50 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_51 = { class: "sale-history-preview" }
const _hoisted_52 = { class: "noselect" }
const _hoisted_53 = ["checked", "disabled"]
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Include Analysis of Prior Sale in my report")
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", null, [
                _createElementVNode("select", {
                  id: "saleHistoryYears",
                  class: "form-control form-control-sm form-select sale-years ms-1 me-1",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSaleYearChange()))
                }, [
                  _createElementVNode("option", {
                    value: "1",
                    selected: _ctx.defaultSelected('comp')
                  }, "1", 8, _hoisted_7),
                  _hoisted_8,
                  _createElementVNode("option", {
                    value: "3",
                    selected: _ctx.defaultSelected('subject')
                  }, "3", 8, _hoisted_9),
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19
                ], 32)
              ]),
              _hoisted_20
            ]),
            (this.hasHistoryData() && _ctx.saleHistoryFetched)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.saleHistoryList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "qs-table-row qs-table-alt-color-row",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: _normalizeClass(["custom-control-input", _ctx.isCheckBoxDisabled(item.isSelected, item.isDisabled, item.armsLength) ? 'hoverDisabled' : '']),
                                onChange: ($event: any) => (_ctx.onCheckBoxChange($event, index)),
                                disabled: _ctx.isCheckBoxDisabled(item.isSelected, item.isDisabled, item.armsLength),
                                checked: _ctx.isCheckBoxChecked(item.isSelected, item.isDisabled)
                              }, null, 42, _hoisted_27)
                            ]),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDate(item.saleDate)), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDate(item.recordedDate)), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatNumber(item.price)), 1),
                            _createElementVNode("div", _hoisted_31, _toDisplayString(item.documentType), 1),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.translationArmsLength(item.armsLength)), 1),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(item.grantor), 1),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(item.grantee), 1),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(item.documentNumber), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : (!this.hasHistoryData() && _ctx.saleHistoryFetched)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_Loader, {
                            key: 0,
                            showLBackDrop: true,
                            showLoadingText: true,
                            loadingText: "Loading..."
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_42, [
                  _createElementVNode("input", {
                    id: "nonArmsLength",
                    type: "checkbox",
                    class: "me-2",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNonArmsLengthChange($event))),
                    checked: _ctx.excludeNonArmsLength,
                    disabled: !_ctx.allowInteraction()
                  }, null, 40, _hoisted_43),
                  _hoisted_44
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_45, [
                  _createElementVNode("input", {
                    id: "includeReportAddenda",
                    type: "checkbox",
                    class: "me-2",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onIncludeInAddendaChange($event))),
                    checked: _ctx.includeInAddenda,
                    disabled: !_ctx.allowInteraction()
                  }, null, 40, _hoisted_46),
                  _hoisted_47
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              (_ctx.includeAnalysis)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Please note that data provided by QuickSource will overwrite any previously entered analysis in the report."))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.analysisOfPriorSales), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_52, [
                _createElementVNode("input", {
                  id: "includeAnalysis",
                  type: "checkbox",
                  class: "me-2",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onIncludeAnalysisChange($event))),
                  checked: _ctx.includeAnalysis,
                  disabled: !_ctx.allowInteraction()
                }, null, 40, _hoisted_53),
                _hoisted_54
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveSelections && _ctx.saveSelections(...args))),
              disabled: !_ctx.allowInteraction()
            }, "Save", 8, _hoisted_55),
            _hoisted_56
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}